// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__3Gy-r","label":"Category_label__3RV1W","content":"Category_content__2ePyD","header":"Category_header__2g41e","location":"Category_location__1pibN"};